import * as React from 'react';

import { cn } from '@ais-ui/utils';

const inputStyles =
  'flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-xs transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(inputStyles, className)}
        ref={ref}
        // Disable browser autocomplete by default to prevent unwanted suggestions
        // Individual inputs can override this by passing autoComplete prop explicitly
        autoComplete="off"
        aria-autocomplete="none"
        onWheel={(e) => e.currentTarget.blur()}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input, inputStyles };
